<template>
  <g class="heatmap-parties">
    <g class="logos shadows">
      <g
        v-for="party in parties"
        :key="party.pid"
        class="animated-icon"
        :transform="getTransform(party)"
      >
        <image x="-18" y="-18" :href="require(`../assets/${party.pid}.png`)" width="36" height="36" />
        <title>{{ party[`name_${lang}`] }}</title>
      </g>
    </g>
    <g class="logos">
      <g
        v-for="party in parties"
        :key="party.pid"
        :transform="getTransform(party, false)"
      >
        <image x="-18" y="-18" :href="require(`../assets/${party.pid}.png`)" width="36" height="36" />
        <title>{{ party[`name_${lang}`] }}</title>
      </g>
    </g>
  </g>
</template>

<script>
import parties from '../data/party_averages.json'

export default {
  name: 'PartyScatter',
  components: {
  },
  props: {
    width: Number,
    height: Number,
    xScale: Function,
    yScale: Function,
    margin: Object,
    compare: Boolean,
  },
  data() {
    return {
      parties,
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getTransform(party, moving = true) {
      if (this.compare && moving) {
        return 'translate(' + this.xScale(party.leftright_compare) + ', ' + this.yScale(party.conslib_compare) + ')';
      }
      return 'translate(' + this.xScale(party.leftright_num) + ', ' + this.yScale(party.conslib_num) + ')';
    },
  }
}
</script>

<style lang="scss">
.logos {
  opacity: 0.8;
}

.animated-icon {
  transition: transform 1s, opacity .5s;
}

.logos.shadows {
  opacity: 0.25;
}
</style>